import { Slot } from "radix-ui";
import type { ComponentProps } from "react";
import { tv, type VariantProps } from "tailwind-variants";

const headingVariants = tv({
  base: "tracking-tight [&>strong]:font-normal",
  variants: {
    size: {
      1: "text-4xl lg:text-6xl",
      2: "text-3xl lg:text-4xl",
      3: "text-2xl lg:text-3xl",
      4: "text-xl lg:text-2xl",
      5: "text-lg uppercase tracking-wider all-small-caps leading-snug",
      6: "text-base uppercase tracking-wider all-small-caps leading-snug",
    },
  },
});

type HeadingElement = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

type HeadingProps = ComponentProps<HeadingElement> &
  VariantProps<typeof headingVariants> & {
    as?: HeadingElement;
    asChild?: boolean;
  };

const Heading = ({
  as = "h2",
  asChild,
  className,
  size,
  ...props
}: HeadingProps) => {
  if (!props.children) return null;

  const Component = asChild ? Slot.Root : as;

  return (
    <Component className={headingVariants({ size, className })} {...props} />
  );
};

Heading.displayName = "Heading";

export { Heading, headingVariants };
export type { HeadingProps };
